import React, { useContext } from 'react';
import './flexipay.css';
import imagesHeader from './logosImage.png';
import bestChoice from '../../assets/images/flexiPay/bestChoice.png';
import recomended from '../../assets/images/flexiPay/recommend.png';
import trusted from '../../assets/images/flexiPay/trusted.png';
import { Button, Divider } from '@mui/material';
import { MyContext } from '../../context';

const FlexiPay = () => {
  const { pageData } = useContext(MyContext);

  return (
    <div className="flexipai-body">
      <section className="container">
        <div className="flexipay-header">
          {pageData?.flexiPay?.header}
          <div className="flexipay-header-right">
            <img loading="lazy" src={recomended} alt=""></img>
            <img loading="lazy" src={bestChoice} alt=""></img>
            <img loading="lazy" src={trusted} alt=""></img>
          </div>
        </div>
        <div className="flexipay-card-wrap">
          {pageData?.flexiPay?.cardContent?.map((item, index) => item.content)}
        </div>
      </section>
    </div>
  );
};

export default FlexiPay;
